import HttpClientToken from '../../services/HttpClientToken';

import { AutoridadResolutoriaProps, defaultAutoridadResolutoria } from '../../interfaces/catalogos/AutoridadResolutoriaInterface';

export const AutoridadResolutoria = () => {

    return new Promise<AutoridadResolutoriaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/AutoridadResolutoria/', token)
            .then( ({ data } : { data : AutoridadResolutoriaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerAutoridadResolutoria = () => {

    return new Promise<AutoridadResolutoriaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/AutoridadResolutoria/ObtenerAutoridadResolutoria', token)
            .then( ({ data } : { data : AutoridadResolutoriaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarAutoridadResolutoria = ( params: AutoridadResolutoriaProps ) => {

    return new Promise<AutoridadResolutoriaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/AutoridadResolutoria/Actualizar', params, token)
            .then( ({ data } : { data : AutoridadResolutoriaProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultAutoridadResolutoria } );
            });

        }

    });

}

export const AgregarAutoridadResolutoria = ( params: AutoridadResolutoriaProps ) => {

    return new Promise<AutoridadResolutoriaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/AutoridadResolutoria/Agregar', params, token)
            .then( ({ data } : { data : AutoridadResolutoriaProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultAutoridadResolutoria } );
            });

        }

    });

}
